// client/src/components/search/SearchResults.js
import React, { useState, useEffect } from 'react';
import StockCard from '../StockCard';
import SortingControl from '../SortingControl';

const SearchResults = ({
  results,
  loading,
  loadingProgress,
  error,
  sortBy,
  sortOrder,
  onSortChange,
  onSortOrderChange,
  sortStocks,
  currentCategory,
  activeFilterLabel,
  onRetry,
  onAddToPortfolio
}) => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="results-section">
      {/* Results Header with Count and Sorting */}
      <div className="results-header">
        <h2 className="results-title">
          {loading ? (
            loadingProgress && loadingProgress.total > 0
              ? `Lade ${loadingProgress.loaded} von ${loadingProgress.total}...`
              : 'Suche läuft...'
          ) : (
            `${results.length} ${results.length === 1 ? 'Ergebnis' : 'Ergebnisse'}${activeFilterLabel ? ` für ${activeFilterLabel}` : ''}`
          )}
        </h2>
        <SortingControl
          sortBy={sortBy}
          onSortChange={onSortChange}
          sortOrder={sortOrder}
          onSortOrderChange={onSortOrderChange}
          context="search"
        />
      </div>

      {/* Loading State */}
      {loading && (
        <div className="loading-placeholder" role="status" aria-label="Ergebnisse werden geladen">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="skeleton-card"></div>
          ))}
        </div>
      )}

      {/* Error State */}
      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
          <p>{error}</p>
          <button className="retry-button" onClick={onRetry}>
            <i className="fas fa-redo" aria-hidden="true"></i> Erneut versuchen
          </button>
        </div>
      )}

      {/* Results Grid */}
      {!loading && !error && results.length > 0 && (
        <div className="stock-grid">
          {sortStocks(results, sortBy, sortOrder).map(stock => (
            <StockCard
              key={stock.id}
              stock={stock}
              sortBy={currentCategory ? currentCategory.valueKey : sortBy}
              onAddToPortfolio={onAddToPortfolio}
              initialExpanded={false}
            />
          ))}
        </div>
      )}

      {/* No Results */}
      {!loading && !error && results.length === 0 && (
        <div className="no-results">
          <i className="fas fa-search" aria-hidden="true"></i>
          <p>Keine Aktien gefunden. Versuche andere Filtereinstellungen.</p>
        </div>
      )}

      {/* Scroll to Top */}
      {showScrollTop && (
        <button
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          aria-label="Nach oben scrollen"
        >
          <i className="fas fa-chevron-up" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
};

export default SearchResults;
